var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:flex justify-center items-center hidden cursor-pointer text-sm select-none leading-5 transition duration-150 ease-in border-t-2",class:[
          _vm.isCurrentPage ? 'border-luxcaddy text-luxcaddy bg-luxcaddy-100' : 'border-transparent hover:border-luxcaddy hover:text-luxcaddy hover:bg-luxcaddy-200',
          _vm.getWidthClass
      ],on:{"click":function($event){_vm.currentPage = _vm.page}}},[_vm._v(" "+_vm._s(_vm.page)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }